/**
 * Right-side marketing panel for the onboarding/login flow.
 *
 * Currently a placeholder — the Figma design specifies a full-bleed image
 * with a "Did you know?" testimonial overlay, but the asset pipeline for
 * onboarding imagery is not in place yet. This component owns the rounded
 * container so swapping in the real image later only touches one spot.
 */
const OnboardingMarketingPanel = () => {
  return (
    <div className="bg-quaternary text-tertiary flex h-full w-full items-center justify-center rounded-[20px]">
      <span className="text-sm">Marketing image placeholder</span>
    </div>
  );
};

OnboardingMarketingPanel.displayName = 'OnboardingMarketingPanel';

export default OnboardingMarketingPanel;
